import { Injectable, inject } from '@angular/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { Capacitor } from '@capacitor/core';
import { AnalyticsService } from '../analytics/analytics.service';
import { HttpService } from '../http/http.service';
import { JitApi } from '../../api/jit/jit-api';

@Injectable({
  providedIn: 'root',
})
export class PushMessagingService {
  private httpService = inject(HttpService);
  private analyticsService = inject(AnalyticsService);

  constructor() {
    FirebaseMessaging.addListener('notificationReceived', (event) => {
      console.log('PushMessagingService: notificationReceived: ', { event });
    });
    FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      console.log('PushMessagingService: notificationActionPerformed: ', { event });
    });
  }

  async requestPermissions(): Promise<void> {
    try {
      // Don't request for push notifications on web
      if (!Capacitor.isNativePlatform()) {
        return;
      }

      const { receive } = await FirebaseMessaging.requestPermissions();
      if (receive == 'granted') {
        const token = await this.getToken();
        await JitApi.request(this.httpService, this.analyticsService).setFcmToken(token);
      }
    } catch (error) {
      this.analyticsService.handleError(error, 'Request messaging permissions');
    }
  }

  private async getToken(): Promise<string> {
    const { token } = await FirebaseMessaging.getToken();
    return token;
  }
}
